module.exports = __webpack_public_path__ + "img/wheel-center.bb0f1aa0.svg";